<template>
  <div class="loading-spinner">
    <div
      v-for="n in 12"
      :key="n"
      class="loading-bar"
      :style="getBarStyle(n)"
    ></div>
  </div>
</template>

<script>
export default {
  name: "LoadingSpinner",
  methods: {
    getBarStyle(index) {
      const delay = (index - 1) * 0.1; // Delay each segment
      return {
        transform: `rotate(${index * 30}deg) translate(0, -10px)`,
        animationDelay: `${delay}s`,
      };
    },
  },
};
</script>

<style scoped>
.loading-spinner {
  position: relative;
  width: 35px;
  height: 35px;
}

.loading-bar {
  position: absolute;
  top: 40%;
  left: 50%;
  width: 3px;
  height: 7px;
  background-color: black;
  border-radius: 2px;
  transform-origin: center;
  animation: fade 1.2s linear infinite;
}

@keyframes fade {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.1;
  }
  100% {
    opacity: 1;
  }
}
</style>
